import { useEffect, useRef, useState } from 'react';
import { contactContent } from '@/mocks/contact';

export default function FloatingContact() {
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  return (
    <div
      ref={containerRef}
      className="fixed bottom-5 right-5 md:bottom-6 md:right-6 z-[60] flex flex-col items-end gap-3"
    >
      {/* Panel */}
      <div
        className={`w-[280px] bg-background-50 rounded-lg border border-background-200/60 overflow-hidden shadow-xl transition-all duration-300 origin-bottom-right ${
          open
            ? 'opacity-100 scale-100 translate-y-0 pointer-events-auto'
            : 'opacity-0 scale-95 translate-y-2 pointer-events-none'
        }`}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 bg-primary-500">
          <span className="text-sm font-bold text-foreground-50 dark:text-foreground-950">
            {contactContent.title}
          </span>
          <button
            type="button"
            onClick={() => setOpen(false)}
            aria-label="关闭"
            className="w-7 h-7 flex items-center justify-center rounded-md text-foreground-50/80 dark:text-foreground-950/70 hover:bg-foreground-50/20 transition-colors"
          >
            <i className="ri-close-line text-lg" />
          </button>
        </div>

        {/* Body */}
        <div className="px-5 py-5">
          {/* QR Code */}
          <div className="flex flex-col items-center text-center">
            {contactContent.qrcode ? (
              <img
                src={contactContent.qrcode}
                alt={`${contactContent.qrcodeLabel}二维码`}
                className="w-36 h-36 object-contain rounded-lg border border-background-200/60"
              />
            ) : (
              <div className="w-36 h-36 flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300/70 text-foreground-400">
                <i className="ri-qr-code-line text-4xl mb-2" />
                <span className="text-xs font-label leading-relaxed">
                  二维码
                  <br />
                  稍后提供
                </span>
              </div>
            )}
            <p className="mt-3 text-xs text-foreground-300 font-label leading-relaxed">
              {contactContent.qrcodeTip}
            </p>
          </div>
        </div>
      </div>

      {/* Floating Button */}
      <button
        type="button"
        onClick={() => setOpen(!open)}
        aria-label="联系我们"
        className={`relative w-14 h-14 flex items-center justify-center rounded-full bg-primary-500 text-foreground-50 dark:text-foreground-950 shadow-xl transition-all duration-300 hover:bg-primary-600 hover:scale-105 ${
          open ? 'rotate-45' : ''
        }`}
      >
        <i className="ri-customer-service-2-line text-2xl" />
        {/* Pulse ring */}
        <span className="absolute inset-0 rounded-full bg-primary-500/40 animate-ping pointer-events-none" />
      </button>
    </div>
  );
}